import React from 'react'

import { useLightMode } from '@/hooks/useLightMode'

import { Box } from '@chakra-ui/react'

import {
  Card,
  CardHeader,
  Box as DarkBox,
  Skeleton,
  tokenPrefix,
} from '@hivewatch/dark'

const SKELETON_ROW_COUNT = 4

/**
 * Placeholder rows shown while the modal's grouping pages load, so the
 * list reveals once instead of streaming in. Each row is a real collapsed
 * group card shell (no chevron; the inner row mirrors CardCollapsibleRow's
 * metrics) with a pulsing title bar matching the incidents table skeleton.
 */
export const TeamStaleGroupsSkeleton = () => {
  const colorScheme = useLightMode()

  return (
    <Box
      data-testid='team-stale-work-skeleton'
      display='flex'
      flexDirection='column'
      gap='12px'
    >
      {Array.from({ length: SKELETON_ROW_COUNT }, (_, index) => (
        <Card colorScheme={colorScheme} key={index} pointerEvents='none'>
          <CardHeader>
            <DarkBox alignItems='center' display='flex' mb='10px' minH='24px'>
              <Skeleton
                bg={`${tokenPrefix(colorScheme)}bg.skeleton`}
                borderRadius='4px'
                height='16px'
                width='40%'
              />
            </DarkBox>
          </CardHeader>
        </Card>
      ))}
    </Box>
  )
}
